import { Button, ButtonProps } from '@nextui-org/react';
import { FaUsers } from 'react-icons/fa6';
import Icon from '../base/Icon';
import { useNavigate } from 'react-router-dom';

export default function UsersButton(props: ButtonProps) {
  const navigate = useNavigate();
  const usersClickHandler = () => () => {
    navigate('/users');
  };

  const isActive = window.location.pathname === '/users';

  return (
    <Button
      onPress={usersClickHandler()}
      {...props}
      isIconOnly
      className={`${isActive ? 'active-user-btn' : 'user-btn'}`}
    >
      <Icon icon={FaUsers} />
    </Button>
  );
}
